import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const DateIcon: React.FunctionComponent<IconProps> = ({
  width = 15,
  height = 17,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={15} viewBoxHeight={17} {...rest}>
    <path d="M3.32031 7.5H7.5V11.6797H3.32031V7.5ZM13.3203 15V5.85938H1.67969V15H13.3203ZM13.3203 1.67969C13.763 1.67969 14.1536 1.84896 14.4922 2.1875C14.8307 2.52604 15 2.91667 15 3.35938V15C15 15.4427 14.8307 15.8333 14.4922 16.1719C14.1536 16.5104 13.763 16.6797 13.3203 16.6797H1.67969C1.21094 16.6797 0.807292 16.5104 0.46875 16.1719C0.15625 15.8333 0 15.4427 0 15V3.35938C0 2.91667 0.15625 2.52604 0.46875 2.1875C0.807292 1.84896 1.21094 1.67969 1.67969 1.67969H2.5V0H4.17969V1.67969H10.8203V0H12.5V1.67969H13.3203Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/icon/date.icon.tsx